import { render, staticRenderFns } from "./specialCustomerLabels.vue?vue&type=template&id=34d358e2&scoped=true&"
import script from "./specialCustomerLabels.vue?vue&type=script&lang=js&"
export * from "./specialCustomerLabels.vue?vue&type=script&lang=js&"
import style0 from "./specialCustomerLabels.vue?vue&type=style&index=0&id=34d358e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d358e2",
  null
  
)

export default component.exports